<template>
  <div class="my-5 px-3">
    <div v-if="!loading">
      <v-btn color="info" @click="saveChanges">Save Changes</v-btn>
      <div class="price">
        <h1>Price:</h1>
        <v-text-field
          label="Price"
          @change="editPrice($event)"
          box
          :value="show(this.data.price)"
        ></v-text-field>
      </div>
      <div class="measurements">
        <h1>Measurement group:</h1>
        <!-- here will go select with all measurement groups available -->
        <v-select
          box
          :items="measurements"
          item-text="name"
          item-value="id"
          label="Measurements group"
          class="materials-input"
          v-model="data.measurementid"
        >
        </v-select>
      </div>
      <div class="addons">
        <h1>Addons:</h1>
        <div class="content">
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(item, index) in data.addons"
              :key="item.id"
            >
              <div slot="header">
                {{ item.label }} ---<span class="font-weight-bold">{{ item.type }}</span>
              </div>
              <v-card>
                <v-layout>
                  <v-flex>
                    <v-text-field
                      label="Label"
                      @change="editAddon($event, index, 'label')"
                      box
                      :value="item.label"
                    ></v-text-field>
                    <div v-if="item.type == 'checkbox'">
                      <v-text-field
                        label="Price"
                        @change="editAddon($event, index, 'price')"
                        box
                        :value="show(item.price)"
                      ></v-text-field>
                      <v-checkbox v-model="item.value" label="Default State"></v-checkbox>
                    </div>
                    <div v-if="item.type == 'select'">
                      <div
                        class="grey lighten-1 my-1 pa-2"
                        v-for="(option, index) in item.options"
                        :key="option.label"
                      >
                        <v-text-field
                          label="Option Label"
                          @change="editAddon($event, index, 'label', item.options)"
                          box
                          :value="option.label"
                        ></v-text-field>
                        <h2>Options:</h2>
                        <v-text-field
                          label="Price"
                          @change="editAddon($event, index, 'price', item.options)"
                          box
                          :value="show(option.price)"
                        ></v-text-field>
                      </div>
                    </div>
                    <v-btn color="error" @click.stop="deleteAddon(index, data.addons)"
                      >Delete addon</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <div slot="header">Add new</div>
              <v-card>
                <v-radio-group v-model="radioGroup">
                  <v-radio label="Checkbox" value="checkbox"></v-radio>
                  <v-radio label="Select" value="select"></v-radio>
                </v-radio-group>

                <div v-if="radioGroup == 'checkbox'">
                  <v-form v-model="checkBoxForm">
                    <v-text-field
                      :rules="inputRules"
                      label="Label"
                      box
                      v-model="newAddon.label"
                    ></v-text-field>
                    <v-text-field
                      :rules="inputRules"
                      label="Price"
                      box
                      v-model="newAddon.price"
                    ></v-text-field>
                    <v-checkbox
                      v-model="newAddon.value"
                      label="Default State"
                    ></v-checkbox>
                    <v-btn :disabled="!checkBoxForm" color="info" @click="add">Add</v-btn>
                  </v-form>
                </div>
                <div v-else-if="radioGroup == 'select'">
                  <v-form v-model="selectForm">
                    <v-text-field
                      :rules="inputRules"
                      label="Label"
                      box
                      v-model="newSelect.label"
                    ></v-text-field>
                  </v-form>
                  <h4>Options:</h4>
                  <v-layout row wrap>
                    <v-flex
                      class="pa-2 blue lighten-5 mx-2 my-4"
                      xl3
                      lg4
                      sm6
                      xs12
                      v-for="(iteme, index) in newSelect.options"
                      :key="iteme.label"
                    >
                      <v-text-field
                        :value="iteme.label"
                        label="Option Label"
                        box
                        readonly
                      ></v-text-field>
                      <v-text-field
                        :value="iteme.price"
                        label="Option price "
                        box
                        readonly
                      ></v-text-field>
                      <v-btn @click="deleteAddon(index, newSelect.options)" color="error"
                        >Delete Field</v-btn
                      >
                    </v-flex>
                  </v-layout>

                  <h4>Add Option:</h4>
                  <div>
                    <v-form v-model="optionForm">
                      <v-text-field
                        :rules="inputRules"
                        label="Label"
                        box
                        ref="selectLabel"
                      ></v-text-field>
                      <v-text-field
                        :rules="inputRules"
                        label="Price"
                        box
                        ref="selectPrice"
                      ></v-text-field>
                      <p>If option is free please put 0$!</p>
                      <v-btn
                        :disabled="!optionForm"
                        color="info"
                        @click="addOptionToAddons"
                        >Add Option</v-btn
                      >
                    </v-form>
                  </div>
                  <p>{{ selectMsg }}</p>
                  <v-btn
                    @click="addSelectToAddons"
                    :disabled="!selectForm"
                    color="primary"
                    >Add Select Field to Addons</v-btn
                  >
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>
      <br />
      <div class="materials">
        <h1>Materials:</h1>
        <div class="content">
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(item, index) in data.materials"
              :key="item.id"
            >
              <div slot="header">{{ item.label }}</div>
              <v-card>
                <v-text-field label="Label" box v-model="item.label"></v-text-field
                >Options:
                <v-layout row wrap justify-space-between>
                  <v-checkbox
                    class="mx-1"
                    v-for="material in usedMaterials(item.options, materials)"
                    v-model="material.checked"
                    @change="changeMaterialChecked($event, material, index)"
                    :key="material.name"
                    :label="material.name"
                  ></v-checkbox>
                </v-layout>
                <v-select
                  box
                  :items="item.options"
                  label="Default Material"
                  v-model="item.measurementvalue"
                ></v-select>

                <v-btn color="error" @click.stop="deleteAddon(index, data.materials)"
                  >Delete Material</v-btn
                >
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <div slot="header">Add new</div>
              <v-card>
                <v-layout>
                  <v-flex>
                    <v-form ref="materialForm">
                      <v-text-field
                        label="Label"
                        box
                        v-model="newMaterial.label"
                      ></v-text-field>
                      <v-layout row wrap justify-space-between>
                        <v-checkbox
                          class="mx-1"
                          v-for="material in materials"
                          @change="checkedMaterial($event, material)"
                          :key="material"
                          :label="material"
                        ></v-checkbox>
                      </v-layout>
                      <!-- <v-text-field label="Add new material option" box ref="newMaterialOption"></v-text-field>
                  <v-btn @click="addMaterialOption">Add option</v-btn> -->
                      <v-select
                        box
                        :items="newMaterial.options"
                        label="Default Material"
                        v-model="newMaterial.measurementvalue"
                      ></v-select>
                      <v-btn color="info" @click="addMaterial">Add</v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </div>
    </div>
    <Loader v-else />
  </div>
</template>

<script>
import { db } from "../firebase.js";
import Loader from "@/components/Loader";
export default {
  components: {
    Loader,
  },
  data() {
    return {
      inputRules: [(v) => !!v || "This filed is required"],
      checkBoxForm: false,
      optionForm: false,
      suitId: "",
      loading: true,
      data: [],
      radioGroup: 1,
      newAddon: {
        label: "",
        price: 0,
        value: false,
      },
      newoption: {
        label: "",
        price: 0,
      },
      newSelect: {
        id: "",
        label: "",
        type: "select",
        options: [],
        value: {
          label: "",
          price: 0,
        },
      },
      newMaterial: {
        label: "",
        type: "select",
        measurementvalue: "",
        options: [],
      },
      materials: [
        "Taslan",
        "Polycotton",
        "Spandex",
        "Cordura",
        "Taslan stretch",
        "Lycra",
      ],
      measurements: [],
    };
  },
  methods: {
    getKey(name) {
      return Symbol(name);
    },
    getOptions(options) {
      let result = [];
      this.materials.forEach((item) => {
        options.includes(item)
          ? result.push({ value: true, label: item })
          : result.push({ value: false, label: item });
      });
      return result;
    },
    addMaterial() {
      this.data.materials.push({
        id: this.newMaterial.label.replace(/\s|\//gi, ""),
        ...this.newMaterial,
      });
      this.newMaterial = {
        label: "",
        type: "select",
        measurementvalue: "",
        options: [],
      };
      this.$refs.materialForm.reset();
    },
    checkedMaterial(e, material) {
      if (e) this.newMaterial.options.push(material);
      else
        this.newMaterial.options = this.newMaterial.options.filter(
          (el) => el !== material
        );
    },
    add() {
      let obj = {
        price: this.newAddon.price * 100,
        label: this.newAddon.label,
        value: this.newAddon.value,
      };
      this.data.addons.push({
        ...obj,
        id: this.newAddon.label.replace(/\s|\//gi, ""),
        type: "checkbox",
      });
      this.newAddon = {
        label: "",
        price: 0,
        value: false,
      };
    },
    show(price) {
      return price / 100 + " $";
    },
    deleteAddon(index, items) {
      items.splice(index, 1);
    },
    editPrice(e) {
      this.data.price = parseFloat(e.replace(/[^\d]*/g, "")) * 100;
    },
    editAddon(e, index, target, obj = this.data.addons) {
      let data;
      target == "price"
        ? (data = parseFloat(e.replace(/[^\d]*/g, "")) * 100)
        : (data = e);
      obj[index][target] = data;
    },
    editMaterial(e, index) {
      this.data.materials.options[index] = e;
    },
    saveChanges() {
      this.loading = true;
      db.collection("data")
        .doc(this.suitId)
        .set(this.data)
        .then((res) => {
          this.loading = false;
          console.log("doc updated ", res);
        });
    },
    addOptionToAddons() {
      // TODO: VALIDATION

      this.newSelect.options.push({
        price: this.$refs.selectPrice._data.lazyValue,
        label: this.$refs.selectLabel._data.lazyValue,
      });
      this.$refs.selectPrice._data.lazyValue = "";
      this.$refs.selectLabel._data.lazyValue = "";
    },
    addSelectToAddons() {
      if (this.newSelect.options.length > 1) {
        this.data.addons.push({
          ...this.newSelect,
          id: this.newSelect.label.replace(/\s|\//gi, ""),
        });
        this.newoption = {
          id: "",
          label: "",
          type: "select",
          options: [],
          value: {
            label: "",
            price: 0,
          },
        };
      } else {
        this.selectMsg = "please add more than 1 select option, otherwise use checkbox!";
        return;
      }
    },
    changeMaterialChecked(event, material, index) {
      if (event) {
        this.data.materials[index].options.push(material.name);
      } else {
        let i = this.data.materials[index].options.indexOf(material.name);
        if (index !== -1) this.data.materials[index].options.splice(i, 1);
      }
    },
    usedMaterials(data, materials) {
      var result = [];
      materials.forEach((el) => {
        if (data.includes(el)) {
          result.push({
            name: el,
            checked: true,
          });
        } else {
          result.push({
            name: el,
            checked: false,
          });
        }
      });
      return result;
    },
    // addMaterialOption(){
    //   this.$refs.newMaterialOption._data.lazyValue
    // }
  },
  created() {
    this.suitId = this.$route.params.id;
    db.collection("data")
      .doc(this.suitId)
      .get()
      .then((items) => {
        this.data = items.data();
        this.loading = false;
      })
      .catch((e) => {
        console.error(`Error happended: ${e}`);
      });
    // FETCHING ALL MEASUREMENT GROUPS
    let result = [];
    db.collection("measurements")
      .get()
      .then((items) => {
        items.forEach((category) => {
          let categoryData = category.data();
          categoryData.id = category.id;
          result.push(categoryData);
        });
      })
      .catch((e) => {
        console.error(`Error happended: ${e}`);
      });
    this.measurements = result;
  },
};
</script>

<style></style>
